import React, {useState} from 'react';

import './styles.scss';
import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import AppButton from '../../../components/app-button';
import {useHistory} from 'react-router-dom';
import RegisterHeader from '../../../components/headers/register-header';
import {strings} from '../../../util/strings';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {
  setIsLanguageSelected,
  setLanguage,
  setWizard,
} from '../../../store/actions';
import {AuthConsumer} from '../../../providers/AuthProvider';
import {createGUID} from '../../../util/utility';

interface MinorUserProps {
  labels: typeof strings.pt.register;
  messagesLabels: typeof strings.pt.messages;
  setWizard(values: any): void;
  setIsLanguageSelected(values: any): void;
  setLanguage(values: any): void;
  languageOptions: any;
  user: any;
}

function MinorUser({
  labels,
  messagesLabels,
  setWizard,
  setIsLanguageSelected,
  setLanguage,
  languageOptions,
  user,
}: MinorUserProps) {
  const history = useHistory();

  const onConfirm = (logout: any) => {
    setWizard({});
    setIsLanguageSelected(false);
    setLanguage(
      languageOptions?.find(
        (option: any) =>
          option.indexOf(navigator.language?.split('-' || '_')[0]) > -1
      ) || messagesLabels?.default_language
    );

    history.push('/');
  };

  return (
    <AuthConsumer>
      {({logout}) => (
        <>
          <Column className="register-main-column">
            <RegisterHeader />
            <Column className="register-container">
              <Row className="register-header-error-row">
                <Header1
                  style={{
                    ...fonts.XL,
                    color: colors.alertRed,
                    fontWeight: 'bold',
                  }}>
                  {labels?.register_underAgeDialogTitle}
                </Header1>
              </Row>
              <Row className="register-header-error-row-responsive">
                <Header1
                  style={{
                    ...fonts.L,
                    color: colors.alertRed,
                    fontWeight: 'bold',
                  }}>
                  {labels?.register_underAgeDialogTitle}
                </Header1>
              </Row>
              <Column
                className="register-minor-user-text"
                style={{...fonts.ML}}>
                <Row className="register-minor-user-text-row">
                  {labels?.register_underAgeDialogText}
                </Row>
                <AppButton
                  variant="secondary"
                  label="Continuar"
                  onClick={() => onConfirm(logout)}
                  className="register-minor-user-button">
                  {labels?.register_underAgeDialogConfirmButton}
                </AppButton>
              </Column>
            </Column>
          </Column>
        </>
      )}
    </AuthConsumer>
  );
}

const mapStateToProps = ({
  strings,
  stringsDefault,
  languageOptions,
  user,
}: any) => ({
  labels: stringsDefault.value.pt.register,
  messagesLabels: stringsDefault.value.pt.messages,
  languageOptions: languageOptions.value,
  user: user.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  setIsLanguageSelected: (value: any) => dispatch(setIsLanguageSelected(value)),
  setLanguage: (value: any) => dispatch(setLanguage(value)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps)(MinorUser));
